/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_PassInputs */

const en_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass`)
};

const fr_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuvé`)
};

const de_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passieren`)
};

const it_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passaggio`)
};

const ru_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проходить`)
};

const es_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar`)
};

const zh_cn2_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经过`)
};

const ja_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合格`)
};

const hi_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तीर्ण`)
};

const pt_pt2_work_order_publish_option_pass = /** @type {(inputs: Work_Order_Publish_Option_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passar`)
};

/**
* | output |
* | --- |
* | "Pass" |
*
* @param {Work_Order_Publish_Option_PassInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_pass = /** @type {((inputs?: Work_Order_Publish_Option_PassInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_PassInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_option_pass(inputs)
	if (locale === "de") return de_work_order_publish_option_pass(inputs)
	if (locale === "it") return it_work_order_publish_option_pass(inputs)
	if (locale === "ru") return ru_work_order_publish_option_pass(inputs)
	if (locale === "es") return es_work_order_publish_option_pass(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_option_pass(inputs)
	if (locale === "ja") return ja_work_order_publish_option_pass(inputs)
	if (locale === "hi") return hi_work_order_publish_option_pass(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_option_pass(inputs)
	return en_work_order_publish_option_pass(inputs)
});